import './Loader.css';

export function Loader() {

  return (
    <div className="page-loading"><div className="loading-spinner" /></div>
  );
};
